import { userService } from '@/services/public/user.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { userModel } from '@/models/api/user.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const USER_MODULE = "public/user";

// ACTIONS
export const GET_ALL_USER = 'getAllUser';
export const GET_USER = 'getUser';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_USER_SUCCESS = "allUserSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_USER_SUCCESS = "getUserSuccess";

export const actions = {
    [GET_ALL_USER]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        return userService
            .getAll(filter)
            .then((result) => {
                commit(ALL_USER_SUCCESS, {data: result});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_USER]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return userService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_USER_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_USER_SUCCESS](state, {data}) {
        let user = data.data || [];
        state.list.data = user;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = user.map(item => userModel(item));
        }
    },
    [GET_USER_SUCCESS](state, data) {
        state.details = userModel(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};
